export const getStatus = (campaign) => {
  if (campaign.active) {
    return {title: "active", color: "tw-bg-green-100"};
  } else if (new Date(campaign.published_at) > new Date()) {
    return {title: "upcoming", color: "tw-bg-yellow-100"};
  } else {
    return {title: "expired", color: "tw-bg-red-100"};
  }
};